<a [routerLink]="['/teamlid']" [queryParams]="{teamlid: member.id}" routerLinkActive="router-link-active">
  <div class="group bg-white dark:bg-slate-900 relative overflow-hidden rounded-md shadow dark:shadow-gray-700 text-center p-6 hover:bg-earth-dark/20 transition-all duration-500 text-black/70">
    <img src={{member.foto}} class="h-20 w-20 object-cover rounded-full shadow dark:shadow-gray-700 mx-auto" alt="">

    <div class="mt-2">
        <a [routerLink]="['/teamlid']" [queryParams]="{teamlid: member.id}" routerLinkActive="router-link-active" class="hover:text-black/70 font-semibold text-lg">{{ member.voornaam + ' ' + member.achternaam }}</a>
        <p class="text-sm text-slate-400">{{ member.rol }}</p>
    </div>

    <ul *ngIf="details" class="mt-2 list-none">
        <li class="inline"><span class="bg-earth-dark/20 inline-block text-black/40 text-xs px-2.5 py-0.5 font-semibold rounded-full" *ngFor="let spec of member.specialisaties">{{spec.naam}}</span></li>
    </ul>

    <div class="flex justify-between mt-2" *ngIf="details">
        <div class="block">
          <span class="text-slate-400"><i class="uil uil-map-marker"></i> {{ parseVestiging(member) }}</span>
        </div>
    </div>

    <!--<span class="absolute top-[10px] ltr:right-4 rtl:left-4">
        <a href="javascript:void(0)" class="text-slate-100 dark:text-slate-700 focus:text-red-600 dark:focus:text-red-600 hover:text-red-600 dark:hover:text-red-600 text-2xl"><i class="mdi mdi-heart"></i></a>
    </span>-->
  </div>
</a>
